import { createSlice } from "@reduxjs/toolkit";

const safeGetFromStorage = (storage, key, parse = false) => {
  try {
    const value = storage.getItem(key);
    return parse ? JSON.parse(value) : value;
  } catch {
    return null;
  }
};

const safeSetToStorage = (storage, key, value) => {
  try {
    storage.setItem(key, value);
  } catch {
    // console.warn(`Failed to set key "${key}" in storage.`);
  }
};

const safeRemoveFromStorage = (storage, key) => {
  try {
    storage.removeItem(key);
  } catch {
    // console.warn(`Failed to remove key "${key}" from storage.`);
  }
};

const initialState = {
  statusLoading: false,
  accessToken: safeGetFromStorage(localStorage, "accessToken"),
  refreshToken: safeGetFromStorage(localStorage, "refreshToken"),
  userData: safeGetFromStorage(localStorage, "userData", true),
  imageTypesData: [],
};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setStatusLoading: (state, action) => {
      state.statusLoading = action.payload;
    },

    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      if (action.payload) {
        safeSetToStorage(localStorage, "accessToken", action.payload);
      } else {
        safeRemoveFromStorage(localStorage, "accessToken");
      }
    },

    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      if (action.payload) {
        safeSetToStorage(localStorage, "refreshToken", action.payload);
      } else {
        safeRemoveFromStorage(localStorage, "refreshToken");
      }
    },

    setUserData: (state, action) => {
      state.userData = action.payload;
      if (action.payload) {
        safeSetToStorage(
          localStorage,
          "userData",
          JSON.stringify(action.payload)
        );
      } else {
        safeRemoveFromStorage(localStorage, "userData");
      }
    },

    clearAccessToken: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.userData = null;
      safeRemoveFromStorage(localStorage, "accessToken");
      safeRemoveFromStorage(localStorage, "refreshToken");
      safeRemoveFromStorage(localStorage, "userData");
    },

    setImageTypesData: (state, action) => {
      state.imageTypesData = action.payload || [];
    },

    clearImageTypesData: (state) => {
      state.imageTypesData = [];
    },
  },
});

export const {
  setStatusLoading,
  setAccessToken,
  setRefreshToken,
  setUserData,
  clearAccessToken,
  setImageTypesData,
  clearImageTypesData,
} = commonSlice.actions;

export default commonSlice.reducer;
